import { useTranslation } from 'react-i18next';

interface FooterProps {
  steps: number;
  currentStep: number;
  onSubmit: () => void;
  submitForm: boolean;
  moveBackStep: () => void;
  disable: boolean;
}

export const Footer = ({
  steps,
  currentStep,
  onSubmit,
  submitForm,
  moveBackStep,
  disable,
}: FooterProps) => {
  const { t } = useTranslation('onboarding');
  return (
    <div className="mt-2 flex flex-col gap-2 md:mt-10">
      <progress
        className="progress progress-primary w-full"
        value={currentStep}
        max={steps}
      ></progress>
      <p className="text-right text-sm">
        {t('footer.pagination', {
          currentStep,
          steps,
        })}
      </p>
      <div className="flex w-full items-start justify-between">
        {currentStep > 1 ? (
          <button className="cursor-pointer text-sm" onClick={moveBackStep}>
            {t('footer.back')}
          </button>
        ) : (
          <div></div>
        )}
        <button
          disabled={submitForm || (disable && currentStep !== steps)}
          className="btn btn-primary w-56 rounded-full"
          onClick={onSubmit}
        >
          {submitForm ? (
            <span className="loading loading-dots loading-md text-primary self-center"></span>
          ) : currentStep === steps ? (
            t('footer.submit')
          ) : (
            t('footer.next')
          )}
        </button>
      </div>
    </div>
  );
};
